<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M4 9C3.45 9 3 8.55 3 8C3 7.45 3.45 7 4 7C4.55 7 5 7.45 5 8C5 8.55 4.55 9 4 9ZM12 9C11.45 9 11 8.55 11 8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8C13 8.55 12.55 9 12 9ZM7 8C7 8.55 7.45 9 8 9C8.55 9 9 8.55 9 8C9 7.45 8.55 7 8 7C7.45 7 7 7.45 7 8Z" ></path>
  </svg>
</template>